/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';
import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import {
  FormattedMessage,
  injectIntl,
} from 'react-intl';
import {
  Grid,
  Row,
  Col,
  Panel,
  Form,
  FormGroup,
  ControlLabel,
  Button,
  FormControl,
} from 'react-bootstrap';
import startOfDay from 'date-fns/start_of_day';
import endOfDay from 'date-fns/end_of_day';
import addDays from 'date-fns/add_days';
import isAfter from 'date-fns/is_after';
import isBefore from 'date-fns/is_before';
import min from 'date-fns/min';
import CSSModules from 'react-css-modules';
import config from 'loracfg';
import Toolbar from 'loracoms/Toolbar';
import DatePicker from 'loracoms/DatePicker';
import InlineSelect from 'loracoms/InlineSelect';
import Nvl from 'loracoms/Nvl';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { hexValidator } from 'lorautils/Validators';
import { getTokenCookies } from 'lorautils/cookies/auth';
import { getDeviceList } from 'loraapi/lora_device';
import styles from './styles/main.scss';


const propTypes = {
  app: React.PropTypes.object.isRequired,
  appId: React.PropTypes.string.isRequired,
  intl: React.PropTypes.any.isRequired,
  pushState: React.PropTypes.func.isRequired,
};

class ExportView extends React.Component {

  static handleDisableDate(d, from) {
    return isAfter(d, min(addDays(from, 7), new Date())) ||
      isBefore(d, from);
  }

  constructor(props) {
    super(props);
    this.state = {
      app: props.app,
      from: startOfDay(new Date()),
      to: endOfDay(new Date()),
      format: 'csv',
      exportType: 'all',
      deveui: null,
      errTips: null,
      devList: [],
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.exportview');
    this.handleChangeDev = this.handleChangeDev.bind(this);
    this.handleExport = this.handleExport.bind(this);
  }

  // componentDidMount() {
  //   this.loadDevices();
  // }

  componentWillReceiveProps(nextProps) {
    const { app } = nextProps;
    if (app !== this.props.app) {
      this.setState({ app });
    }
  }

  loadDevices(s, errTip) {
    const { appId } = this.props;
    const args = {
      app: appId,
      pageSize: 1000,
      limit: 1000,
      q: `deveui:*${s}*`,
    };
    getDeviceList(args).then((resp) => {
      const dev = resp.body.list;
      if (!_.isNil(dev) && dev.length > 0) {
        this.setState({
          errTips: null,
          deveui: s,
        });
      } else {
        this.setState({
          errTips: errTip(this.intlMsg.msg('deverrtips')),
          deveui: s,
        });
      }
      // this.setState({
      //   devList: resp.body.list,
      // });
    });
  }

  searchDevice(s, errTip) {
    this.loadDevices(s, errTip);
  }

  checkDeveui(arr, v) {
    let result = false;
    if (arr.length === 0) {
      result = false;
    }
    else {
      arr.forEach((item) => {
        if (item.deveui === v) {
          result = true;
        }
      });
    }
    return result;
  }

  exportLink() {
    const { appId } = this.props;
    const { exportType, deveui } = this.state;
    let devEUI = '';
    if (exportType === 'all') {
      this.setState({
        deveui: null,
      });
    } else if (exportType === 'one') {
      devEUI = `&node=${deveui}`;
    }
    return (
      config.apiBase +
      '/application/download?appeui=' + appId + devEUI +
      '&start=' + this.state.from.valueOf() +
      '&end=' + this.state.to.valueOf() +
      '&encoding=' + this.state.format +
      '&access_token=' + getTokenCookies()
    );
  }

  handleExport() {
    window.location = this.exportLink();
  }

  handleChangeDev(v) {
    const errTip = msg => (
      <div styleName="errtip-mes">
        <i className="fa fa-exclamation-triangle" />
        {' '}
        {msg}
      </div>
    );
    const valid = hexValidator(16);
    if (valid(v).valid) {
      this.searchDevice(v, errTip);
    } else {
      this.setState({
        errTips: errTip(valid(v).errmsg),
        deveui: v,
      });
    }
  }

  formatDeveui(value) {
    if (value.indexOf('-') !== -1 || value.indexOf(':') !== -1) {
      return value.split(':').join('').split('-').join('');
    }
    return value;
  }

  render() {
    const { pushState } = this.props;
    const { app, format, from = new Date(), to = new Date() } = this.state;
    const { data: appData = {} } = app;

    const breadcrumb = [{
      content: <FormattedMessage id="application.breadcrumb.application" />,
      onClick: () => pushState('/application'),
    }, {
      content: <Nvl val={appData.name} status={app.status} />,
      active: true,
    }];

    const { errTips, exportType, deveui } = this.state;
    let devValid = false;
    if (exportType !== 'all') {
      if (errTips !== null || deveui === null) {
        devValid = true;
      }
    }
    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            <Toolbar breadcrumb={breadcrumb} />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Panel bsStyle="aisz-white" header={this.intlMsg.msg('panelheader')}>
              <Form horizontal>
                <FormGroup>
                  <Col md={1}>
                    <ControlLabel className="aisz-control-label">
                      {this.intlMsg.msg('exporttype.label')}
                    </ControlLabel>
                  </Col>
                  <Col md={8}>
                    <InlineSelect
                      options={[{
                        label: this.intlMsg.msg('exporttype.optionall'),
                        value: 'all',
                      }, {
                        label: this.intlMsg.msg('exporttype.optionone'),
                        value: 'one',
                      }]}
                      values={[exportType]}
                      onChange={(selected) => {
                        this.setState({
                          exportType: selected[0],
                          errTips: null,
                          deveui: null,
                        });
                      }}
                    />
                  </Col>
                </FormGroup>
                {
                  this.state.exportType === 'one' ?
                    <FormGroup>
                      <Col md={1}>
                        <ControlLabel className="aisz-control-label">
                          {this.intlMsg.msg('choosedev.label')}
                        </ControlLabel>
                      </Col>
                      <Col md={4}>
                        <div styleName="export-data">
                          <FormControl
                            className="aisz-form-control"
                            placeholder={this.intlMsg.msg('choosedev.placeholder')}
                            onChange={e => this.handleChangeDev(this.formatDeveui(e.target.value))}
                          />
                          {errTips}
                        </div>
                      </Col>
                    </FormGroup> : null
                }
                <FormGroup>
                  <Col md={1}>
                    <ControlLabel className="aisz-control-label">
                      {this.intlMsg.msg('timerange.label')}
                    </ControlLabel>
                  </Col>
                  <Col md={4}>
                    <DatePicker
                      date={from}
                      onSelect={(date) => {
                        this.setState({ from: startOfDay(date), to: endOfDay(date) });
                      }}
                    />
                    {' '}
                    <DatePicker
                      date={to}
                      disabled={d => ExportView.handleDisableDate(d, from)}
                      onSelect={(date) => { this.setState({ to: endOfDay(date) }); }}
                    />
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col md={1}>
                    <ControlLabel className="aisz-control-label">
                      {this.intlMsg.msg('format.label')}
                    </ControlLabel>
                  </Col>
                  <Col md={4}>
                    <InlineSelect
                      options={[{
                        label: <span><span className="filetypes filetypes-csv" />{' '}CSV</span>,
                        value: 'csv',
                        active: true,
                      }, {
                        label: <span><span className="filetypes filetypes-json" />{' '}JSON</span>,
                        value: 'json',
                      }]}
                      values={[format]}
                      onChange={selected => this.setState({ format: selected[0] })}
                    />
                  </Col>
                </FormGroup>
                <FormGroup>
                  <Col mdOffset={1} md={4}>
                    <Button
                      bsStyle="aisz-primary"
                      disabled={!this.state.from || !this.state.to || devValid}
                      onClick={this.handleExport}
                    >
                      <FormattedMessage id="applicationdetail.exportview.export.btn" />
                      {' '}
                      <i className="fa fa-download" aria-hidden="true" />
                    </Button>
                  </Col>
                </FormGroup>
              </Form>
            </Panel>
          </Col>
        </Row>
      </Grid>
    );
  }
}

ExportView.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  appId: ownProps.params.id,
  app: state.app.getApp,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
};


export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CSSModules(ExportView, styles, { allowMultiple: true })));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/ExportView/index.jsx